<template>
  <div>
    <b-modal
      id="trip-accessibility-modal"
      ref="modalRef"
      title="Find trip"
      hide-footer
      @hidden="onHidden"
    >
      <b-form-group label="Trip Number">
        <b-form-input
          v-model.number="tripNumber"
          type="number"
          placeholder="Enter trip number"
          autofocus
        />
      </b-form-group>
      <h4
        v-if="noTripFound"
        class="text-danger text-center"
      >
        No trip found with this number
      </h4>
      <div
        v-else-if="foundTrip"
        class="d-flex justify-content-between align-items-center mb-1"
      >
        <trip-status-badge
          :status="foundTrip.state"
          style="letter-spacing: -0.5px; font-size: 11px"
        />
        <b-button
          variant="success"
          small
          @click="redirectToDetails"
        >
          Go to details
        </b-button>
      </div>
      <b-button
        block
        :disabled="!tripNumber || searching"
        variant="primary"
        @click="searchTrip"
      >
        <b-spinner
          v-if="searching"
          small
        />
        <span v-else>Search trip</span>
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { ref, getCurrentInstance } from '@vue/composition-api'
import {
  BModal,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { errorNotification } from '@/utils/toast-notifications'
import tripsStore from '@/views/trips/store'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import TripStatusBadge from '@/views/trips/components/TripStatusBadge.vue'

export default {
  components: {
    BModal,
    TripStatusBadge,
    BFormInput,
    BFormGroup,
    BButton,
    BSpinner,
  },
  setup(_, ctx) {
    useRegisterStoreModule('trips', tripsStore)

    const tripNumber = ref('')
    const searching = ref(false)
    const noTripFound = ref(false)
    const foundTrip = ref(null)
    const searchTrip = async () => {
      try {
        foundTrip.value = null
        noTripFound.value = false
        searching.value = true
        const result = await ctx.root.$store.dispatch('trips/fetchTripsList', {
          trip_id: tripNumber.value,
        })

        noTripFound.value = !result.data.data.trips.length
        // eslint-disable-next-line prefer-destructuring
        foundTrip.value = result.data.data.trips[0]
      } catch (err) {
        errorNotification('Try again')
      } finally {
        searching.value = false
      }
    }

    const inst = getCurrentInstance()
    const redirectToDetails = () => {
      inst.refs.modalRef.hide()
      ctx.root.$router.push({
        path: `/trips/${foundTrip.value.id}`,
      })
    }

    const onHidden = () => {
      tripNumber.value = ''
      noTripFound.value = false
      foundTrip.value = null
    }

    return {
      redirectToDetails,
      foundTrip,
      noTripFound,
      onHidden,
      searchTrip,
      searching,
      tripNumber,
    }
  },
}
</script>

<style></style>
